module.exports = __webpack_public_path__ + "media/images/icons/flags/AI-f091cb8897c2cb7aaac1bb187f3885c1.svg";